<div id="userComp" class="users">
  <div id="userCompHeader" class="data_header">
    <div id="userHeaderLeft" class="left_side_section">
        <div id="userHeaderData" class="mr-3 pending-user-label">
            <div id="pendingUsersHeading" class="title">
              {{pendingUsersHeading}}
            </div>
            <div id="pendingUserData" class="results" *ngIf="displayPendingUsersList?.length > 0">
              <span i18n="@@pending-users.page-count">Showing<strong> {{ showFrom }} - {{ showTo }} </strong>of<strong> {{ paginationCount }} Pending Users</strong></span>
            </div>
        </div>
        <div id="searchGrp" class="search_group" [ngClass]="{'search_group-lan':!isEnglish}">
        <div id="searchInput" class="input-group" [ngClass]="{'input-group-lan':!isEnglish}">          
          <input #searchValue type="search" [(ngModel)]="searchData" autocomplete="off" class="form-control"  (keyup.enter)="searchtheUserssonEnter(searchData)" placeholder="{{searchPlaceholder}}" (ngModelChange)="clearSearch(searchData)"/>
          <div id="searchResultDropdown" ngbDropdown class="input-group-append show">
            <button ngbDropdownToggle type="button" class="btn btn-primary dropdown-toggle" id="sizeDropDown"
              aria-haspopup="true" aria-expanded="false" [ngClass]="{'button-lan':isEnglish}">
              {{ valueForSearchUsers }}
            </button>
            <div id="dropdownMenu" ngbDropdownMenu aria-labelledby="sizeDropDown">
              <a ngbDropdownItem selected="selected" *ngIf="valueForSearchUsers!=nameHeading" (click)="onSelectChange('1')">{{nameHeading}}</a>
              <a ngbDropdownItem *ngIf="valueForSearchUsers!=emailHeading" (click)="onSelectChange('2')">{{emailHeading}}</a>
              <a ngbDropdownItem *ngIf="valueForSearchUsers!=countryHeading" (click)="onSelectChange('4')">{{countryHeading}}</a>
              <a ngbDropdownItem *ngIf="(valueForSearchUsers!=retailerNameHeading)&&(loginUserRole == intelAdmin)" (click)="onSelectChange('3')">{{retailerNameHeading}}</a>
              <a ngbDropdownItem *ngIf="(valueForSearchUsers!=storeNameHeading)&&(loginUserRole == retailerHq || loginUserRole == regionalHq)" (click)="onSelectChange('5')">{{storeNameHeading}}</a>
            </div>
          </div>
        </div>
        <button type="button" class="btn btn-primary ml-2 pendingUsersSearchIcon" (click)="searchActiveUsers(searchData)" ></button>
        </div>
    </div>
    <iposcen-spinner-overlay *ngIf="showRetailGif" [isCard]="true" (getStatus)='isLoading = $event'></iposcen-spinner-overlay>
    <iposcen-spinner-overlay *ngIf="!showRetailGif" [isCard]="false" (getStatus)='isLoading = $event'></iposcen-spinner-overlay>
    <div id="pendingUserActionBtn" class="action_buttons" [ngClass]="{'mt-3': (!displayPendingUsersList?.length  && !isEnglish)}">
      <button type="button" (click)="approveOrRejectAllSelectedUsers(rejectHeading)" class="btn btn-outline-primary btn-lg gtmUsersRemoveSelected" [ngClass]="isDisabled ? 'default_Border': 'highlights_border'" [disabled]="isAllselectedData.size < 1 " >
        <span i18n="@@pending-users.reject-all-selected">Reject Selected</span>
      </button>
      <button type="button" (click)="approveOrRejectAllSelectedUsers(approveHeading)" class="btn btn-outline-primary btn-lg gtmUsersRemoveSelected" [ngClass]="isDisabled ? 'default_Border': 'highlights_border'" [disabled]="isAllselectedData.size < 1">
        <span i18n="@@pending-users.approve-all-selected">Approve Selected</span>
      </button>
    </div>
  </div>
  <hr />

  <!-- Table data -->
  <div id="pendingUserTableData" class="table-responsive">
      <table id="pendingUsersTable" class="table table-borderless" aria-describedby="pendingUsersList">
          <thead>
            <tr *ngIf="displayPendingUsersList?.length > 0">
              <th scope="col">
                <span class="table_headings">
                  <input class="" type="checkbox" [checked]='isAllselectedData.size === paginationCount' name="list_name" value="" (change)="checkUncheckAll($event.target.checked)"/>
                </span>
              </th>
              <th scope="col" id="name">
                <span class="table_headings" (click)="sort('name')">
                  {{nameHeading}}
                  <span class="chevron_expand"></span>
                </span>
              </th>
              <th scope="col" id="email">
                <span class="table_headings" (click)="sort('email')">
                  {{emailHeading}}
                  <span class="chevron_expand"></span>
                </span>
              </th>
              <th scope="col" id="country">
                <span class="table_headings" (click)="sort('country')">
                  {{countryHeading}}
                  <span class="chevron_expand"></span>
                </span>
              </th>
              <th scope="col" id="retailerName" *ngIf="(loginUserRole == intelAdmin)">
                <span class="table_headings" (click)="sort('retailerName')">
                  {{retailerNameHeading}}
                  <span class="chevron_expand"></span>
                </span>
              </th>
              <th scope="col" id="storeName" *ngIf="(loginUserRole == retailerHq || loginUserRole == regionalHq)">
                <span class="table_headings" (click)="sort('storeName')">
                  {{storeNameHeading}}
                  <span class="chevron_expand"></span>
                </span>
              </th>
              <th scope="col" id="invitedBy" *ngIf="(loginUserRole == retailerHq || loginUserRole == regionalHq)">
                <span class="table_headings" (click)="sort('createdByName')">
                  {{invitedByHeading}}
                  <span class="chevron_expand"></span>
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
              <ng-container *ngFor="let item of displayPendingUsersList;let i = index">
                  <tr>
                      <td>
                        <input type="checkbox" [checked]='isAllselectedData.has(item.email)' name="list_name" (change)="isAllSelected(item)"/>
                      </td>
                      <td>{{item?.name}}</td>
                      <td>{{item?.email}}</td>
                      <td>{{ getTranslatedLoc(item?.location) }}</td>
                      <td  *ngIf="(loginUserRole == intelAdmin)">{{item?.retailerName}}</td>
                      <td  *ngIf="(loginUserRole == retailerHq || loginUserRole == regionalHq)">{{item?.storeName}}</td>
                      <td  *ngIf="(loginUserRole == retailerHq || loginUserRole == regionalHq)">{{item?.createdByName}}</td>
                      <td class="reject_approve_td">
                        <div class="d-flex justify-content-end">
                          <button type="button"class="btn btn-outline-danger btn-sm left_icon_btn mr-3 ml-3" (click)="approveOrRejectSelectedUser(item?.userID,rejectHeading)">
                            <svg class="pending-user-action-btn" width="16" height="16"viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                              <path d="M5.5 5.5C5.63261 5.5 5.75979 5.55268 5.85355 5.64645C5.94732 5.74021 6 5.86739 6 6V12C6 12.1326 5.94732 12.2598 5.85355 12.3536C5.75979 12.4473 5.63261 12.5 5.5 12.5C5.36739 12.5 5.24021 12.4473 5.14645 12.3536C5.05268 12.2598 5 12.1326 5 12V6C5 5.86739 5.05268 5.74021 5.14645 5.64645C5.24021 5.55268 5.36739 5.5 5.5 5.5ZM8 5.5C8.13261 5.5 8.25979 5.55268 8.35355 5.64645C8.44732 5.74021 8.5 5.86739 8.5 6V12C8.5 12.1326 8.44732 12.2598 8.35355 12.3536C8.25979 12.4473 8.13261 12.5 8 12.5C7.86739 12.5 7.74021 12.4473 7.64645 12.3536C7.55268 12.2598 7.5 12.1326 7.5 12V6C7.5 5.86739 7.55268 5.74021 7.64645 5.64645C7.74021 5.55268 7.86739 5.5 8 5.5ZM11 6C11 5.86739 10.9473 5.74021 10.8536 5.64645C10.7598 5.55268 10.6326 5.5 10.5 5.5C10.3674 5.5 10.2402 5.55268 10.1464 5.64645C10.0527 5.74021 10 5.86739 10 6V12C10 12.1326 10.0527 12.2598 10.1464 12.3536C10.2402 12.4473 10.3674 12.5 10.5 12.5C10.6326 12.5 10.7598 12.4473 10.8536 12.3536C10.9473 12.2598 11 12.1326 11 12V6Z"
                                fill="currentColor"/>
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M14.5 3C14.5 3.26522 14.3946 3.51957 14.2071 3.70711C14.0196 3.89464 13.7652 4 13.5 4H13V13C13 13.5304 12.7893 14.0391 12.4142 14.4142C12.0391 14.7893 11.5304 15 11 15H5C4.46957 15 3.96086 14.7893 3.58579 14.4142C3.21071 14.0391 3 13.5304 3 13V4H2.5C2.23478 4 1.98043 3.89464 1.79289 3.70711C1.60536 3.51957 1.5 3.26522 1.5 3V2C1.5 1.73478 1.60536 1.48043 1.79289 1.29289C1.98043 1.10536 2.23478 1 2.5 1H6C6 0.734784 6.10536 0.48043 6.29289 0.292893C6.48043 0.105357 6.73478 0 7 0L9 0C9.26522 0 9.51957 0.105357 9.70711 0.292893C9.89464 0.48043 10 0.734784 10 1H13.5C13.7652 1 14.0196 1.10536 14.2071 1.29289C14.3946 1.48043 14.5 1.73478 14.5 2V3ZM4.118 4L4 4.059V13C4 13.2652 4.10536 13.5196 4.29289 13.7071C4.48043 13.8946 4.73478 14 5 14H11C11.2652 14 11.5196 13.8946 11.7071 13.7071C11.8946 13.5196 12 13.2652 12 13V4.059L11.882 4H4.118ZM2.5 3V2H13.5V3H2.5Z"
                                fill="currentColor" />
                            </svg>
                            {{rejectHeading}}
                          </button>
                          <button type="button" class="btn btn-outline-success btn-sm left_icon_btn gtmPendingUserApprove" (click)="approveOrRejectSelectedUser(item?.userID,approveHeading)">
                            <svg  class="pending-user-action-btn" width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8537 3.64592C13.9002 3.69236 13.9372 3.74754 13.9624 3.80828C13.9876 3.86903 14.0005 3.93415 14.0005 3.99992C14.0005 4.06568 13.9876 4.13081 13.9624 4.19155C13.9372 4.2523 13.9002 4.30747 13.8537 4.35392L6.85365 11.3539C6.80721 11.4005 6.75203 11.4374 6.69129 11.4626C6.63054 11.4878 6.56542 11.5008 6.49965 11.5008C6.43389 11.5008 6.36877 11.4878 6.30802 11.4626C6.24728 11.4374 6.1921 11.4005 6.14565 11.3539L2.64565 7.85392C2.55177 7.76003 2.49902 7.63269 2.49902 7.49992C2.49902 7.36714 2.55177 7.2398 2.64565 7.14592C2.73954 7.05203 2.86688 6.99929 2.99966 6.99929C3.13243 6.99929 3.25977 7.05203 3.35366 7.14592L6.49965 10.2929L13.1457 3.64592C13.1921 3.59935 13.2473 3.56241 13.308 3.5372C13.3688 3.512 13.4339 3.49902 13.4997 3.49902C13.5654 3.49902 13.6305 3.512 13.6913 3.5372C13.752 3.56241 13.8072 3.59935 13.8537 3.64592Z"
                                fill="currentColor" />
                            </svg>
                            {{approveHeading}}
                          </button>
                        </div>
                      </td>
                  </tr>
              </ng-container>
          </tbody>
        </table>
        <ng-container *ngIf='!isLoading && isPendingUsersEmpty; else loading'>
          <p class="center-text" *ngIf="!displayPendingUsersList?.length">
            {{noRecordFound}}
          </p>
        </ng-container>
        <ng-template #loading>
          <p class="text-center" *ngIf="!displayPendingUsersList?.length">{{globConst.LOADING}}</p>
        </ng-template>

  </div>
  <hr/>
  <!-- Pagination -->
  <div id="footer" class="data_footer position-relative">
    <div id="footerDataPagination" class="d-flex flex-column align-items-center" *ngIf="displayPendingUsersList?.length > 0">
      <nav aria-label="pending users pagination">
          <ngb-pagination [collectionSize]="paginationCount" [(page)]="page" [pageSize]="tableSize"
              [rotate]="false" [maxSize]="maxSize" [ellipses]="true" [boundaryLinks]="false"
              (pageChange)="onTableDataChange($event)">
          </ngb-pagination>
      </nav>
      <div id="footerData" class="results mt-2">
        <span i18n="@@pending-users.page-count">Showing<strong> {{ showFrom }} - {{ showTo }} </strong>of<strong> {{ paginationCount }} Pending Users</strong></span>
      </div>
    </div>
  </div>
</div>

<div class="container" id="actionOnPendingUsers">
  <div class="modal-dialog-centered" *ngIf="openModalPopup">
      <div class="modal-backdrop show"></div>
      <div class="modal" id="myModal">
          <div id="modalDialog" class="modal-dialog">
              <div id="modalContent" class="modal-content">
                  <div id="modalCloseIcon" class="close modal_close_icons" data-dismiss="modal" (click)="CloseModal()">
                  </div>
                  <div id="modalBody" class="modal-body">
                      <h2 class="action_heading" *ngIf="!isActionPending">{{actionType}} {{userName}} ?</h2>
                      <div id="successImg" class="action_on_pending_user" *ngIf="isActionPending">
                        <span class="success_img"></span>
                      </div>
                      <div id="successHeading" class="action-success-msg" *ngIf="isActionPending">
                        <span>{{successHeading}}</span>
                      </div>
                      <div id="successMsg" class="on-action-recieved-msg" *ngIf="isActionPending">
                        <span>{{successMessage}}</span>
                      </div>
                  </div>
                  <div id="modalFooterBtn" class="modal-footer" *ngIf="!isActionPending">
                      <button type="button" class="btn btn-outline-primary btn-lg" data-dismiss="modal"
                          (click)="CloseModal()">{{cancelButton}}</button>
                      <button type="button" class="btn btn-primary btn-lg" (click)="actionOnPendingUser(actionType)">{{buttonText}}</button>
                  </div>
                </div>
          </div>
      </div>
  </div>
</div>